const breakpoints = {
  breakpoints: ['480px', '898px', '1280px'],
};

export default breakpoints;
